import { useCallback, useState } from 'react';

/**
 * Claro por defecto para todos. El oscuro existe, pero solo si la persona lo elige: Rodrigo
 * pidió que todo se vea claro, pensando en gente mayor (2026-09-16). No sigue al sistema.
 */
export type Tema = 'claro' | 'oscuro';
const CLAVE = 'libreta:tema';

function leer(): Tema {
  try {
    return localStorage.getItem(CLAVE) === 'oscuro' ? 'oscuro' : 'claro';
  } catch {
    return 'claro';
  }
}

export function useTema(): [Tema, (tema: Tema) => void] {
  const [tema, setTema] = useState<Tema>(leer);
  const cambiar = useCallback((nuevo: Tema) => {
    setTema(nuevo);
    if (nuevo === 'oscuro') document.documentElement.setAttribute('data-tema', 'oscuro');
    else document.documentElement.removeAttribute('data-tema');
    try {
      if (nuevo === 'oscuro') localStorage.setItem(CLAVE, 'oscuro');
      else localStorage.removeItem(CLAVE);
    } catch {
      /* sin almacenamiento: el cambio vale para esta pestaña */
    }
  }, []);
  return [tema, cambiar];
}
